module.exports = __webpack_public_path__ + "img/grid.2a24a0d0.svg";